module.exports = __webpack_public_path__ + "static/media/link.e896666e.svg";